import { wtClientApi } from 'api/clients';

import type { GenericResponse } from 'commons/modules/generic-response';

import { removeEmptyParams } from 'utils/services';

import {
  adaptDataToGenericResponse,
  adaptErrorToGenericResponse,
} from '../shared';

import type { ClientDetailsDto } from './dto';
import { mapClientDetailsDtoToModel, mapUpdatePersonToDto } from './mappers';
import type { ClientDetails, UpdatePerson } from './models';

const CLIENT_STATUS_PATH = '/management/clients/status';
const CLIENT_UPDATE_STATUS_PATH = '/management/clients/update/status';

export const getClientStatus = async (
  params: UpdatePerson,
): Promise<GenericResponse<ClientDetails>> => {
  try {
    const queryParams: Record<string, unknown> = {
      clientId: params.clientId,
      account: params.account ?? '',
      cveStatus: params.cveStatus,
    };
    removeEmptyParams(queryParams, { exclude: ['account'] });

    const response = await wtClientApi.get<ClientDetailsDto>(
      CLIENT_STATUS_PATH,
      { params: queryParams },
    );

    const mappedData = mapClientDetailsDtoToModel(response.data);

    return adaptDataToGenericResponse(mappedData, response.status);
  } catch (error: any) {
    return adaptErrorToGenericResponse(
      error,
      'Ocurrió un error al obtener los datos del cliente',
    );
  }
};

export const updateClientStatus = async (
  body: UpdatePerson,
): Promise<GenericResponse<void>> => {
  try {
    const dto = mapUpdatePersonToDto(body);
    const response = await wtClientApi.post(CLIENT_UPDATE_STATUS_PATH, dto);

    return adaptDataToGenericResponse(null, response.status);
  } catch (error: any) {
    return adaptErrorToGenericResponse(
      error,
      'Ocurrió un error al actualizar el estatus del cliente',
    );
  }
};
